import { useMutation } from '@apollo/client';
import UPDATE_MOST_RECENT_BOOK_LOCATION from 'graphql/mutations/mostRecentBookLocation/UpdateMostRecentBookLocation.graphql';

export default function useUpdateMostRecentBookLocationMutation() {
  return useMutation(UPDATE_MOST_RECENT_BOOK_LOCATION);
}
